import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';

export const PageWrapper = styled.div`
    padding: 0 0 25px;

    ${Screen.ipad} {
        padding: 0 0 30px;
    }

    ${Screen.desktop} {
        padding: 0 0 30px;
    }
`;

export const Title = styled.div`
    color: ${cssVars.fg_gray1_white};
    ${Text.Full.heading2};
    margin: 0 0 16px;

    ${Screen.desktop} {
        padding: 20px 35px;
        margin: 0;
    }
`;

export const ShortParagraph = styled.div`
    top: 30px;
    width: 91%;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: ${radius.small};
    margin: 30px auto 45px;
    ${Text.Mobile.heading4};
    background-color: ${cssVars.bg_ash_dark3};
    color: ${cssVars.fg_gray2_gray3};

    ${Screen.desktop} {
        max-width: 1064px;
        margin: 0 auto 40px;
        padding: 3px 41px;
        ${Text.Desktop.heading2};
    }
`;

export const DescriptionTitle = styled.h1`
    ${Text.Mobile.heading2};
    color: ${cssVars.fg_gray1_white};
    padding: 25px 0 0;

    ${Screen.ipad} {
        ${Text.Ipad.heading3};
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading2};
    }
`;

export const CategorySelectWrapper = styled.div`
    min-height: 184px;
    margin: 25px auto;
    padding: 40px 20px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: ${radius.small};
    ${Text.Mobile.heading4};
    background-color: ${cssVars.bg_sand_dark3};
    color: ${cssVars.fg_black_white};

    ${Screen.ipad} {
        margin: 30px auto;
    }

    ${Screen.desktop} {
        min-height: 190px;
        ${Text.Desktop.heading2};
    }
`;

export const SelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${Screen.desktop} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`;

export const Dropdown = styled.div`
    > div {
        ${Screen.desktop} {
            width: 550px;
            max-width: 550px;
        }
        > div {
            ${Screen.desktop} {
                max-height: 450px;
            }
        }
    }
`;

export const CardsWrapper = styled.div`
    > div {
        padding: 22px 0 25px;
    }

    ${Screen.ipad} {
        > div {
            padding: 27px 0 30px;
        }
    }
    ${Screen.desktop} {
        margin-top: 20px;
    }
`;

export const BtnWrapper = styled.p`
    margin: 0 18px;
    max-width: 1124px;
    padding: 0;

    ${Screen.ipad} {
        margin: 0 30px;
    }

    ${Screen.desktop} {
        margin: 0 auto;
        padding: 0 30px;
    }
`;

export const BtnWrapperOutline = styled.p`
    margin: 0 18px;
    max-width: 1124px;
    padding: 0;
    margin-bottom: 20px;

    ${Screen.ipad} {
        margin: 0 30px 20px;
    }

    ${Screen.desktop} {
        width: 320px;
        margin: 0 auto 20px;
        padding: 0 30px;
    }
`;

export const WrapperTopAttractions = styled.div`
    padding: 16px 0;
`;

export const WrapperSubscribe = styled.div`
    ${Screen.desktop} {
        padding: 0 0 30px;
    }
`;

export const WrapperDescription = styled.div`
    padding: 0 0 11px;
`;
